<p>
  <span>{{ "NAV.PROGRESS_LABEL" | translate: { current: activeMacroStepIndex + 1, total: numberOfMacroSteps } }}</span>
  <span *ngIf="activeStep">{{ 'NAV.' + activeStep.macroStep | translate }}</span>
</p>
<div class="progress-bar-outer">
  <div class="progress-bar-fill" [style]="'width: ' + ( 100 * absoluteProgress ) + '%;'"></div>
</div>
